import { connect } from 'react-redux';
import Accessories from '../../../shared/scripts/components/Accessories/Accessories';
import { initializeAddToCart } from '../actions/cart/add';

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    addToCart: (data, title) => dispatch(initializeAddToCart(data, title)),
  };
};

/**
* Connects the component to the Redux store
* @returns {*}
* @constructor
*/
const AccessoriesContainer = () => {
  return connect(mapStateToProps, mapDispatchToProps)(Accessories);
};

export default AccessoriesContainer;
